/* eslint-disable no-tabs */
import React from 'react';
import { useApolloClient } from '@apollo/client';
import gql from 'graphql-tag';
import { useDownloadDocument } from '../../utils/hooks';
import { SERVER_URL } from '../../config';
import { getPrimary } from '../../styles/colors';
import { BasicButton, LoadingSection } from '../../UI';
import documents from '../../assets/img/documents.png';
import ModalTranslate from './ModalTranslate';
import { getText } from '../../utils/functions';


const PortalAttachmentsList = ({
	portal,
	translate,
	deleteButton = false,
	refetch,
	downloadButton,
	editButton,
	updateState
}) => {
	const client = useApolloClient();

	const deleteAttachment = async id => {
		await client.mutate({
			mutation: gql`
                mutation deleteCouncilPortalAttachment($id: Int!){
                    deleteCouncilPortalAttachment(id: $id){
                        success
                    }
                }
            `,
			variables: {
				id
			}
		});
		const { labels } = portal.config;
		const removeLabel = Object.entries(labels).map(([key, val]) => {
			if (parseInt(key, 10) !== id) {
				return ([key, val]);
			}
			return [];
		});
		const remove = Object.fromEntries(removeLabel);

		updateState({
			...portal.config,
			labels: remove
		});
		refetch();
	};


	return (
		<div onClick={event => {
			event.stopPropagation();
			event.preventDefault();
		}}>
			{portal.attachments.length > 0 ? portal.attachments.map((attachment, index) => (
				<div style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
					marginBottom: '1em',
				}} key={attachment.id} onClick={
					event => {
						event.stopPropagation(); event.preventDefault();
					}}>

					<PortalAttachment
						attachment={attachment}
						translate={translate}
						editButton={editButton}
						downloadButton={downloadButton}
						updateState={updateState}
						deleteAttachment={deleteAttachment}
						deleteButton={deleteButton}
						index={index}
						portal={portal}
					/>
				</div>))
				: translate.no_convene_attachments
			}
		</div>
	);
};

const PortalAttachment = ({
	attachment,
	deleteButton,
	downloadButton,
	deleteAttachment,
	editButton,
	updateState,
	translate,
	portal,
	index
}) => {
	const [downloading, download] = useDownloadDocument();
	const [showSpinner, setShowSpinner] = React.useState(false);
	const lang = {
		es: '',
		en: '',
		gal: '',
		cat: '',
		eu: '',
		fr: '',
		pt: '',
		pl: ''
	};

	React.useEffect(() => {
		let timeout;

		if (downloading) {
			timeout = setTimeout(() => {
				setShowSpinner(true);
			}, 1000);
		} else {
			setShowSpinner(false);
		}

		return () => clearTimeout(timeout);
	}, [downloading]);

	return (
		<>
			<div style={{ display: 'flex', alignItems: 'center' }}>
				<div style={{
					width: '20px',
					marginRight: '.7em',
					display: 'flex',
					alignItems: 'center'
				}}>
					{(downloading && showSpinner) ?
						<LoadingSection size={12} styles={{ display: 'unset' }} />
						: <img src={documents} style={{ width: '100%' }} />
					}
				</div>
				{deleteButton ?
					<div
						style={{
							cursor: 'auto'
						}}
					>{getText(portal.config.labels[attachment.id], translate) || attachment.filename}</div>
					: <div
						onClick={() => download(`${SERVER_URL}/api/councilPortalAttachment/${attachment.id}`, attachment.filename)}
						style={{
							cursor: downloading ? 'wait' : 'pointer'
						}}
					// >{ attachment.filename}</div>
					>{portal.config.labels && portal.config.labels[attachment.id] ?
							portal.config.labels[attachment.id] : attachment.filename}
					</div>
				}
			</div>
			<div style={{ display: 'flex', gap: '.5rem' }}>
				{deleteButton
					&& <BasicButton
						text={translate.new_delete}
						type="text"
						onClick={
							event => {
								event.stopPropagation(); deleteAttachment(attachment.id, index);
							}}
						buttonStyle={{
							cursor: 'pointer',
							padding: '.5em',
							border: `1px solid ${getPrimary()}`,
							color: getPrimary(),
							borderRadius: '4px',
							fontWeight: 'bold',
							height: '30px',
							width: '145px',
						}} />
				}
				{downloadButton
					&& <BasicButton
						text={translate.download}
						type="text"
						onClick={
							event => {
								event.stopPropagation(); download(`${SERVER_URL}/api/councilPortalAttachment/${attachment.id}`, attachment.filename);
							}}
						buttonStyle={{
							cursor: 'pointer',
							marginLeft: '1em',
							padding: '.5em',
							border: `1px solid ${getPrimary()}`,
							color: getPrimary(),
							borderRadius: '4px',
							fontWeight: 'bold',
							height: '30px',
							width: '145px',
						}}
					/>
				}
				{editButton
					&& <ModalTranslate
						translate={translate}
						item={portal.config.labels[attachment.id] || { text: lang, label: '' }}
						name={attachment.filename}
						setLocalState={newData => updateState({
							...portal.config,
							labels: {
								...portal.config.labels,
								[attachment.id]: {
									...portal.config.labels[attachment.id],
									...newData
								}
							}
						})}
						localState={portal.config.labels}
					/>
				}
			</div>
		</>
	);
};

export default PortalAttachmentsList;
